import {takeLatest, put,select} from 'redux-saga/effects';
import {actions as listActions} from '../slices/CompanyListSlice';
import {actions} from '../slices/CompanySlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';

const getSearchCriteria = state => state.employeeList.searchCriteria;

function* getCompanyList({payload: {page, limit, filters}}) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_companies')}`, {
            params: {
                page: page ? page - 1 : null,
                size: limit,
                ...filters,
            }
        });
        yield put({type: listActions.get_list_succeed.type, payload: {...response.data}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: listActions.get_list_failed.type, payload: error});
    }
}



function* createCompany({payload:{params}}) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_companies')}`, {
            ...params
        });
        yield put({type: actions.create_company_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Thêm thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_company_failed.type, payload: error});
    }
}

function* updateCompany({payload:{params}}) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_companies')}/${params.id}`, {
            ...params
        });
        yield put({type: actions.create_company_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_company_failed.type, payload: error});
    }
}



function* assignAdminCompany({payload:{params}}) {
    try {
        const {user,...data} = params;

        const userResponse = yield NetworkHandler.post(`${config.getUrl('bus_staff')}`, {
            ...user,
            org_id:data.id,
            enabled_bus_companies_id: [data.id],
            belong_super_company:false,
            active_super_company:false
        });
        
        const response = yield NetworkHandler.put(`${config.getUrl('bus_companies')}/${data.id}`, {
            ...data,
            admin_id:userResponse.data.id
        });
        

        yield put({type: actions.create_company_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Cập nhật thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.create_company_failed.type, payload: error});
    }
}

function* deleteCompany({payload:{id}}) {
    try {
        const response = yield NetworkHandler.delete(`${config.getUrl('bus_companies')}/${id}`);
        yield put({type: actions.delete_company_succeed.type, payload: {...response}});
        NotificationHandler.notifySuccess('Xoá thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({type: listActions.get_list.type, payload: {...searchCriteria}});
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({type: actions.delete_company_failed.type, payload: error});
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getCompanyList);
    yield takeLatest(actions.create_company.type, createCompany);
    yield takeLatest(actions.update_company.type, updateCompany);
    yield takeLatest(actions.delete_company.type, deleteCompany);
    yield takeLatest(actions.assign_admin_company.type, assignAdminCompany);
}

export default watchRequestDetail;